// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"258":"a336b5ca","529":"15ae506d","585":"17c3e771","627":"859de615","726":"580cd66a","976":"b35aec30","989":"15c835f8"}[chunkId] + ".chunk.js";
};